import React from "react";
import "./Header.scss";
import images from "../../../../utilities/images/images";
import { useHistory } from "react-router-dom";

const Header = ({ paperName, attempts = [],selectedAttempt,onAttemptChange,onBack,backPath,backState }) => {
  // const navigate = useHistory();
  // const handleBackClick = () => {
  //   navigate.push("/TestInstruction");
 const history = useHistory();

  const handleBackClick = () => {
    if (onBack) {
      onBack();            
    } else if (backPath) {
      history.push(backPath, backState);
    } else {
      history.goBack();  
    }
  };

  return (
    <div className="analytics__header">
      <div
        className="analytics__header__left"
        onClick={handleBackClick}
        style={{ cursor: "pointer" }}
      >
        <img src={images.backBtn} alt="backbtn" />
        <div>{paperName}</div>
      </div>

      <div className="analytics__header__right">
          {attempts.length > 0 && (
          <select
            value={selectedAttempt}
            onChange={(e) => onAttemptChange(Number(e.target.value))}
          >
            {attempts.map((a) => (
              <option key={a.id} value={a.id}>
                {a.title}
              </option>
            ))}
          </select>
          )}
      </div>
    </div>
  );
};

export default Header;
